import './needs_refresh_modal.less';

import React, { Component } from 'react';
import withClickOutside from 'react-onclickoutside';

import FocusTrap from 'focus-trap-react';

const NeedsRefreshModalUI = ({ onRefresh })=>
  <div className="needs-refresh-modal">
    <p>This site has expired. Please refresh the site.</p>

    <p>
      <button className="refresh-button" onClick={onRefresh}>
        Refresh
      </button>
    </p>

    <p className="fyi-text">
      For security reasons the content on this site expires after 12 hours.
        You must refresh the site to continue.
    </p>
  </div>;


const NeedsRefreshModalWithClose = withClickOutside(
  class InPageSearchDisplayWithClose extends Component {
    handleClickOutside() {
      this.props.onClose();
    }
    render() {
      return <NeedsRefreshModalUI {...this.props} />;
    }
  }
);

const NeedsRefreshModal = (props)=> (
  <FocusTrap>
    <div className="needs-refresh-modal-background">
      <NeedsRefreshModalWithClose {...props} />
    </div>
  </FocusTrap>
);


export default NeedsRefreshModal;
